'use client'
import React from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'

import VacancySection from '../../../app/_components/Section/VacancySection'
import vacanciesData from '../../../app/_utilities/data/sections/vacancies.json'
import PageBanner from '../PageBanner'

const CareerImageSlider = dynamic(
  () => import('../../../app/_components/Sliders/CareerImageSlider'),
  {
    ssr: false,
  },
)
const TeamSlider = dynamic(() => import('../../../app/_components/Sliders/TeamSlider'), {
  ssr: false,
})
const Perks = dynamic(() => import('../../../app/_components/Sliders/Perks'), {
  ssr: false,
})

const Careers: React.FC = () => {
  return (
    <>
      <Head>
        <title>Career - Pyther Innovation</title>
        {/* <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SERVER_URL}/career`} /> */}
      </Head>
      <PageBanner pageName={'Career'} pageTitle={'Develop your Future'} />

      {/* Image slider section */}
      <CareerImageSlider />

      {/* Work environment section */}
      <TeamSlider />

      {/* perks of pyther member section */}
      <Perks />

      {/* Apply for job section */}
      <VacancySection vacancies={vacanciesData} />
    </>
  )
}
export default Careers
